import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QrislyComponent } from './qrisly.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { UploadQrisComponent } from './components/upload-qris/upload-qris.component';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LibsModule } from '../../libs/libs.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { QrisListTableComponent } from './components/qris-list-table/qris-list-table.component';
import { DeleteQrisModalComponent } from './components/delete-qris-modal/delete-qris-modal.component';
import { QrislyRoutingModule } from './qrisly-routing.module';

@NgModule({
  declarations: [
    QrislyComponent,
    UploadQrisComponent,
    QrisListTableComponent,
    DeleteQrisModalComponent
  ],
  imports: [
    CommonModule,
    NzCardModule,
    AntDModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    LibsModule,
    NgxDaterangepickerMd,
    QrislyRoutingModule
  ],
  exports: [
    QrislyComponent,
    UploadQrisComponent
  ]
})
export class QrislyModule { }
